import PropTypes from 'prop-types';
import React from 'react';
import SharedCard from './SharedCard';
import CoreSharedCard from './CoreSharedCard';
import { sanitizeUrl } from '@braintree/sanitize-url';
import diagnosticImage from '../../../../images/personalization_tool.png';

export default class DiagnosticCard extends React.Component {
  static propTypes = {
    genericIncentive: PropTypes.object,
    learnerDashboard: PropTypes.bool,
    diagnostic: PropTypes.shape({
      image_url: PropTypes.string,
      id: PropTypes.string.isRequired,
      incentive: PropTypes.shape({
        claim_message: PropTypes.string,
        incentive_activity: PropTypes.shape({
          status: PropTypes.string,
        }),
        incentive_message: PropTypes.string,
      }),
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      tagline: PropTypes.string.isRequired,
    }).isRequired,
    program: PropTypes.shape({
      remove_content_images: PropTypes.bool,
      slug: PropTypes.string.isRequired,
    }),
    renderAsLegacy: PropTypes.bool,
  };

  render() {
    const { diagnostic, genericIncentive, learnerDashboard, program, renderAsLegacy } = this.props;
    const diagnosticUrl = sanitizeUrl(
      `/student/personalized_dashboard/${program.slug}/${diagnostic.slug}${window.location.search}`
    );
    const iconUrl = diagnostic.image_url ? diagnostic.image_url : diagnosticImage;
    const CardComponent = renderAsLegacy ? SharedCard : CoreSharedCard;

    return (
      <CardComponent
        {...diagnostic}
        cardType="diagnostic"
        destinationUrl={diagnosticUrl}
        genericIncentive={genericIncentive}
        iconUrl={iconUrl}
        learnerDashboard={learnerDashboard}
        program={program}
      />
    );
  }
}
